import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8731ab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asahi-information-container"
}
const _hoisted_2 = { class: "text-white fw-bold" }
const _hoisted_3 = { class: "delivery-date-wrapper" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "delivered-icon" }
const _hoisted_6 = { class: "angle-icon" }
const _hoisted_7 = {
  key: 1,
  class: "asahi-mobile-information-container asahi-order-information-accordion w-100 fw-medium f-14"
}
const _hoisted_8 = {
  class: "accordion w-100",
  id: "asahi-order-information-accordion"
}
const _hoisted_9 = { class: "accordion-item" }
const _hoisted_10 = { class: "accordion-header w-100 d-flex align-items-center" }
const _hoisted_11 = { class: "row align-items-center header-row" }
const _hoisted_12 = {
  key: 0,
  class: "col-11"
}
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { class: "text-white" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "text-white fw-bold col-5 order-details-mobile"
}
const _hoisted_17 = { class: "exclamation-icon" }
const _hoisted_18 = { class: "col-1" }
const _hoisted_19 = {
  id: 'asahi-order-information-accordion-collapse-' + 0,
  class: "accordion-collapse collapse w-100"
}
const _hoisted_20 = { class: "accordion-body pt-1" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 align-items-center justify-content-center" }
const _hoisted_23 = { class: "row align-items-center justify-content-center" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "row align-items-center justify-content-center" }
const _hoisted_26 = { class: "col-12 d-flex justify-content-center" }
const _hoisted_27 = {
  key: 0,
  class: "row align-items-center justify-content-center"
}
const _hoisted_28 = { class: "delivered-icon" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiSelectHeader = _resolveComponent("AsahiSelectHeader")!
  const _component_DeliveryDatePicker = _resolveComponent("DeliveryDatePicker")!
  const _component_AsahiProgressBar = _resolveComponent("AsahiProgressBar")!
  const _component_DeliveredIcon = _resolveComponent("DeliveredIcon")!
  const _component_AngleUpDownIcon = _resolveComponent("AngleUpDownIcon")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")!

  return (!_ctx.isMobile && !_ctx.isMoreSection)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Your delivery preferences')) + ":", 1),
        _createVNode(_component_AsahiSelectHeader, {
          modelValue: _ctx.selectedShipmentId ?? _ctx.shipToOptions[0]?.value,
          options: _ctx.shipToOptions,
          "onUpdate:modelValue": _ctx.setShipmentWrapper,
          icon: _ctx.shipToIcon,
          placeholder: _ctx.shipToOptions[0]?.label,
          isTicket: false,
          "is-white": true,
          "no-offset": true,
          isDatePickerOpen: _ctx.isDatePickerOpen,
          name: "asahi-order-information-set-shipment",
          "has-calendar-exception": _ctx.hasAnyShipToException,
          "calendar-exception-note": _ctx.$t('There has been a change in delivery for establishments marked in red. Click on the establishment to view the changes.')
        }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen", "has-calendar-exception", "calendar-exception-note"]),
        _createVNode(_component_AsahiSelectHeader, {
          modelValue: _ctx.selectedOrderType,
          options: _ctx.transportOptionsAsSelectBoxOptions,
          "onUpdate:modelValue": _ctx.onOrderTransportTypeSelectionWrapper,
          icon: _ctx.trackIcon,
          placeholder: _ctx.$t('Shipping method'),
          isTicket: false,
          "is-white": true,
          isDatePickerOpen: _ctx.isDatePickerOpen,
          name: "asahi-order-information-transport-type",
          "has-calendar-exception": _ctx.hasSelectedShipmentCalendarException,
          "calendar-exception-note": _ctx.$t('For the transport types marked in red, the delivery has changed. Click on the transport type to view the changes.')
        }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "isDatePickerOpen", "has-calendar-exception", "calendar-exception-note"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DeliveryDatePicker, {
            ref: "deliveryDatePickerRef",
            modelValue: _ctx.deliveryDateSelected,
            shipmentId: _ctx.selectedOrderType,
            placeholder: _ctx.$t('Request date'),
            holidayDays: _ctx.holidaysConfig,
            "onUpdate:modelValue": _ctx.onDateSelectionWrapper,
            onOpen: _ctx.handleDatePickerOpen,
            onClose: _ctx.handleDatePickerClose,
            "has-calendar-exception": _ctx.hasSelectedTransportCalendarException
          }, null, 8, ["modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue", "onOpen", "onClose", "has-calendar-exception"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bottle-container", _ctx.messageColorClass?.borderColor])
        }, [
          _createVNode(_component_AsahiProgressBar, {
            percentage: _ctx.cashFilledPercentage,
            error: _ctx.errorWeight,
            success: _ctx.successWeight
          }, null, 8, ["percentage", "error", "success"])
        ], 2),
        (_ctx.hasAnyShipToException)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_AsahiButton, {
                type: "red",
                onClick: _ctx.displayCalendarExceptionModal
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_DeliveredIcon)
                  ]),
                  _createTextVNode("   " + _toDisplayString(_ctx.$t('Delivery changes')) + "   ", 1),
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_AngleUpDownIcon, { up: false })
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Ship to') + " "), 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentShippingPlace?.label) + " - " + _toDisplayString(_ctx.currentShippingMethod?.label) + " - " + _toDisplayString(_ctx.formattedDeliveryDate), 1),
                      _createTextVNode(),
                      _createVNode(_component_AsahiProgressBar, {
                        percentage: _ctx.cashFilledPercentage,
                        error: _ctx.errorWeight,
                        success: _ctx.successWeight,
                        "message-type": "icon-only"
                      }, null, 8, ["percentage", "error", "success"]),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        (_ctx.hasAnyShipToException)
                          ? (_openBlock(), _createBlock(_component_ExclamationIcon, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Order details')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["bottle-container col-6", _ctx.messageColorClass?.borderColor])
                    }, [
                      _createVNode(_component_AsahiProgressBar, {
                        "is-white": true,
                        percentage: _ctx.cashFilledPercentage,
                        error: _ctx.errorWeight,
                        success: _ctx.successWeight,
                        "message-type": "mobile"
                      }, null, 8, ["percentage", "error", "success"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "accordion-button collapsed",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": '#asahi-order-information-accordion-collapse-' + 0,
                    "aria-expanded": "false",
                    "aria-controls": 'asahi-order-information-accordion-collapse-' + 0,
                    onClick: _cache[0] || (_cache[0] = (event) => _ctx.toggleAccordion(event))
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_AsahiSelectHeader, {
                      modelValue: _ctx.selectedShipmentId ?? _ctx.shipToOptions[0]?.value,
                      options: _ctx.shipToOptions,
                      "onUpdate:modelValue": _ctx.setShipmentWrapper,
                      icon: _ctx.shipToIcon,
                      placeholder: _ctx.shipToOptions[0]?.label,
                      "is-white": true,
                      "no-offset": true,
                      "is-mobile": true,
                      "selected-modal": false,
                      title: _ctx.$t('Ship to'),
                      name: "asahi-order-information-set-shipment",
                      "has-calendar-exception": _ctx.hasAnyShipToException,
                      "calendar-exception-note": _ctx.$t('There has been a change in delivery for establishments marked in red. Click on the establishment to view the changes.')
                    }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title", "has-calendar-exception", "calendar-exception-note"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_AsahiSelectHeader, {
                      modelValue: _ctx.selectedOrderType,
                      options: _ctx.transportOptionsAsSelectBoxOptions,
                      "onUpdate:modelValue": _ctx.onOrderTransportTypeSelectionWrapper,
                      icon: _ctx.trackIcon,
                      placeholder: _ctx.$t('Shipping method'),
                      "is-white": true,
                      "is-mobile": true,
                      "selected-modal": false,
                      title: _ctx.$t('Type of Transport'),
                      name: "asahi-order-information-transport-type",
                      "has-calendar-exception": _ctx.hasSelectedShipmentCalendarException,
                      "calendar-exception-note": _ctx.$t('For the transport types marked in red, the delivery has changed. Click on the transport type to view the changes.')
                    }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "icon", "placeholder", "title", "has-calendar-exception", "calendar-exception-note"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_DeliveryDatePicker, {
                      ref: "deliveryDatePickerRef",
                      modelValue: _ctx.deliveryDateSelected,
                      shipmentId: _ctx.selectedOrderType,
                      placeholder: _ctx.$t('Request date'),
                      holidayDays: _ctx.holidaysConfig,
                      "is-mobile": true,
                      "onUpdate:modelValue": _ctx.onDateSelectionWrapper,
                      "has-calendar-exception": _ctx.hasSelectedTransportCalendarException
                    }, null, 8, ["modelValue", "shipmentId", "placeholder", "holidayDays", "onUpdate:modelValue", "has-calendar-exception"])
                  ]),
                  (_ctx.hasAnyShipToException)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_component_AsahiButton, {
                          type: "red",
                          onClick: _ctx.displayCalendarExceptionModal
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_28, [
                              _createVNode(_component_DeliveredIcon)
                            ]),
                            _createTextVNode("   " + _toDisplayString(_ctx.$t('Delivery changes')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_AsahiProgressBar, {
                      "is-white": true,
                      percentage: _ctx.cashFilledPercentage,
                      error: _ctx.errorWeight,
                      success: _ctx.successWeight,
                      "message-type": "mobile-long"
                    }, null, 8, ["percentage", "error", "success"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
}